import { render, staticRenderFns } from "./PayNew.vue?vue&type=template&id=9470e708&"
import script from "./PayNew.vue?vue&type=script&lang=js&"
export * from "./PayNew.vue?vue&type=script&lang=js&"
import style0 from "./PayNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports